import gsap from "gsap";

export default class Header {
  constructor(el) {
    this.header = document.querySelector("[js-header]");
    this.hamburger = document.querySelector("[js-hamburger]");
    this.nav = document.querySelector("[js-nav]");
    this.overlay = document.querySelector("[js-overlay]");
    this.submenuParents = document.querySelectorAll(".has-submenu");
    this.searchToggleBtns = null;
    this.searchBar = null;

    this.init();
  }

  init() {
    this.searchToggleBtns = document.querySelectorAll("[js-search-toggle-btn]");
    this.searchBar = document.querySelector("#headerSearchBar");

    this.addEventListeners();
    this.createSearchEventListeners();
  }

  addEventListeners() {
    if (this.hamburger) {
      this.hamburger.addEventListener("click", () => this.toggleNavHandler());
    }

    this.submenuParents.forEach((parent) => {
      const link = parent.querySelector(".header__nav-list-item-link");
      const submenu = parent.querySelector(".header__subnav-list");

      if (!submenu) return;

      parent.addEventListener("mouseenter", () => {
        if (window.innerWidth > 1024) this.openSubmenu(submenu);
      });

      parent.addEventListener("mouseleave", () => {
        if (window.innerWidth > 1024) this.closeSubmenu(submenu);
      });

      link.addEventListener("click", (e) => {
        if (window.innerWidth <= 1024) {
        //  e.preventDefault();
          const isOpen = parent.classList.contains("submenu--open");
              if (isOpen) {
                  this.closeSubmenu(submenu, parent);
                  document.location.href = parent.querySelector('a').href;
              } else {
                  e.preventDefault();
                  this.openSubmenu(submenu, parent);
                  parent.querySelector('a').href = parent.querySelector('a').getAttribute('data-url');
              }
          }

      });
    });
  }

  toggleNavHandler() {
    const isOpen = this.hamburger.getAttribute("aria-expanded") === "true";
    isOpen ? this.closeNav() : this.openNav();
  }

  openNav() {
    this.hamburger.setAttribute("aria-expanded", true);
    document.body.classList.add("nav-open"); // disable scroll if needed

    gsap.set(this.overlay, { display: "block" });
    gsap.to(this.nav, { xPercent: -100, duration: 0.5, ease: "power3.out" });
    gsap.to(this.overlay, { opacity: 1, duration: 0.5, ease: "power3.out" });
  }

  closeNav() {
    this.hamburger.setAttribute("aria-expanded", false);
    document.body.classList.remove("nav-open");

    gsap.to(this.nav, { xPercent: 0, duration: 0.5, ease: "power3.out" });
    gsap.to(this.overlay, { opacity: 0, duration: 0.5, ease: "power3.out" });
    gsap.set(this.overlay, { display: "none", delay: 0.51 });

    this.submenuParents.forEach((parent) => {
      if (parent.classList.contains("submenu--open")) {
        const submenu = parent.querySelector(".header__subnav-list");
        this.closeSubmenu(submenu, parent);
      }
    });
  }

  openSubmenu(submenu, parent) {
    if (window.innerWidth <= 1024) {
      this.submenuParents.forEach((p) => {
        if (p !== parent && p.classList.contains("submenu--open")) {
          const otherSubmenu = p.querySelector(".header__subnav-list");
          this.closeSubmenu(otherSubmenu, p);
        }
      });
    }

    if (parent) parent.classList.add("submenu--open");

    gsap.set(submenu, { display: "block", height: "auto", opacity: 0 });
    const height = submenu.offsetHeight;

    gsap.fromTo(submenu, { height: 0, opacity: 0 }, { height, opacity: 1, duration: 0.4, ease: "power2.out" });
  }

  closeSubmenu(submenu, parent) {
    if (parent) parent.classList.remove("submenu--open");

    gsap.to(submenu, {
      height: 0,
      opacity: 0,
      duration: 0.3,
      ease: "power2.inOut",
      onComplete: () => gsap.set(submenu, { display: "none" }),
    });
  }

  createSearchEventListeners() {
    this.searchToggleBtns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        const type = btn.dataset.type;
        if (type === "open") {
          this.searchToggleBtns.forEach((el) => {
            el.setAttribute("aria-expanded", true);
          });
          this.searchBar.classList.add("--expanded");
        } else {
          this.searchToggleBtns.forEach((el) => {
            el.setAttribute("aria-expanded", false);
          });
          this.searchBar.classList.remove("--expanded");
        }
      });
    });
  }
}
